<template>
    <div class="content">
        <img src="@/assets/day.svg" alt="ある社員の1日" class="img_photos">


        <div class="content">

            <div>
                <h3>ある弊社社員の１日のスケジュール</h3>
                <table>
                    <tr>
                        <th>
                            <div class="daytable_th">7:00</div>
                        </th>
                        <td>
                            <div class="td_1">
                                <div class="sch_item">起床</div>
                                <div class="sch_desc">だいたいこのくらいの時間に起きて、朝食をとったり<br>身支度を整えます。</div>
                            </div>
                        </td>

                    </tr>
                    <tr>
                        <th>
                            <div class="daytable_th">8:00 - 8:40</div>
                        </th>
                        <td>
                            <div class="td_1">
                                <div class="sch_item">通勤</div>
                                <div class="sch_desc">通勤時間に音楽を聴いたり、本を読んだりして気持ちを整えています。</div>
                            </div>

                        </td>
                    </tr>
                    <tr>
                        <th>
                            <div class="daytable_th">8:40</div>
                        </th>
                        <td>
                            <div class="td_1">
                                <div class="sch_item">会社に到着</div>
                                <div class="sch_desc">配属先の定時が9時のため、20分前頃に到着するようにしています。</div>
                            </div>

                        </td>
                    </tr>
                    <tr>
                        <th>
                            <div class="daytable_th">9:30 - 9:50 </div>
                        </th>
                        <td>
                            <div class="td_1">
                                <div class="sch_item">朝ミーティング</div>
                                <div class="sch_desc">チームの進捗や、個別の進捗や状況を確認するミーティングを行なっています。</div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>
                            <div class="daytable_th">10:00 - 12:00 </div>
                        </th>
                        <td>
                            <div class="td_1">
                                <div class="sch_item">午前作業</div>
                                <div class="sch_desc">その日のタスクとなっている業務を行います。調査やテストの日もあれば、コーディングを行うこともあります。</div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>
                            <div class="daytable_th">12:00 - 13:00 </div>
                        </th>
                        <td>
                            <div class="td_1">
                                <div class="sch_item">ランチ</div>
                                <div class="sch_desc">お弁当を持って行ったり、たまにはチームで近くのお店に行くこともあります。</div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>
                            <div class="daytable_th">13:00 - 18:00</div>
                        </th>
                        <td>
                            <div class="td_1">
                                <div class="sch_item">午後作業</div>
                                <div class="sch_desc">午後も午前中の作業の続きを行いますが、午後は効率が落ちがちなので、お菓子を食べたりしてモチベーションを保ったりしています。
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>
                            <div class="daytable_th">18:00 </div>
                        </th>
                        <td>
                            <div class="td_1">
                                <div class="sch_item">退社</div>
                                <div class="sch_desc">残業はほとんどないので、帰りに買い物に寄ったり、ジムに行ったりすることもあります。</div>
                            </div>
                        </td>
                    </tr>


                </table>


            </div>
        </div>

    </div>

</template>

<script>
export default {}
</script>

<style>
.daytable_th {
    width: 130px;
    height: 100px;
    background-color:
        #ff83af;
    color: white;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
}


.td_1 {
    width: 400px;
    height: 100px;
    border: 1px solid #ddd;
    padding: 5px;
    background-color: white;
    box-sizing: border-box;
}

.sch_item {

    font-weight: bold;

}

.sch_desc {
    font-size: 14px;

}



@media(max-width:500px) {
    .content td {
        width: 200px;

        font-size: 14px;
    }

    .td_1 {
        width: 250px;
        height: 120px;
    }

    .daytable_th {
        width: 50px;
        height: 120px;
    }
}
</style>